import { storeToRefs } from 'pinia';
import { productsExtraGuaranteeStore } from '~/stores/productsExtraGuarantee';

import type { ProductVariantGql } from '~~/types/product/ProductVariantGql';

import { CUSTOM_QUERIES } from '~~/constants/customQueries';
import extendProducts from '~~/helpers/product/extendProducts';
import { getProductSearchParams } from '~~/helpers/product/getProductSearchParams';
import { useProduct } from '~/utils/ct';

export const useProductsExtraGuaranteeStore = () => {

  const store = productsExtraGuaranteeStore();
  const { productsExtraGuarantee } = storeToRefs(store);
  const load = async ():Promise<void> => {

    if (productsExtraGuarantee.value !== null) {

      return;
    
    }
    const {
      products: extraGuaranteeProducts,
      search: searchExtraGuaranteeProduct,
    } = useProduct<ProductVariantGql>('extra-guarantee-product');
    const { languagePrefix } = usePrefix();

    const { languageAndCountry, countryCode } = useLocalization();
    const { public: { EXTRA_GUARANTEE_PRODUCT_TYPE_ID } } = useRuntimeConfig();
    
    const searchParams = {
      customFilters: `productType(id="${EXTRA_GUARANTEE_PRODUCT_TYPE_ID}")`,
    };
    const productSearchParams = getProductSearchParams(
      searchParams,
      {
        languageAndCountry: languageAndCountry.value,
        languagePrefix,
        includeUnsellableProducts: true,
      },
    );
    await searchExtraGuaranteeProduct({
      ...productSearchParams,
      customQuery: CUSTOM_QUERIES.PRODUCT_SEARCH.extraGuaranteeQuery,
    });

    const products = extraGuaranteeProducts.value?.data?.products?.results || [];

    const extendedProducts = extendProducts(
      products,
      languageAndCountry.value,
      countryCode.value,
      { isPublished: true },
    );

    const filteredProducts = extendedProducts.filter(product => {

      const enabledOnMarket = product.attributesRaw
        ?.find(attr => attr.name === 'enabledOnMarket' && attr.value[languageAndCountry.value] === 'true');

      return enabledOnMarket?.value && Object.keys(enabledOnMarket.value).length > 0;
    
    });

    store.setProducts(filteredProducts);
  
  };

  return {
    ...store,
    productsExtraGuarantee,

    load,
  };

};